import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const AddPartnerData = createSlice({
  name: "AddPartnerData",
  initialState: {
    data: {},
  },
  reducers: {
    addPartnerData: (state, action?: any) => {
      state.data = action.payload;
    },
  },
});
export default AddPartnerData.reducer;
export const { addPartnerData } = AddPartnerData.actions;
